// extracted by mini-css-extract-plugin
export default {"panel":"teamCard_panel__SQeMr","empty":"teamCard_empty__M3Ssx"};